app.controller("AddGroupsWindowController", ["$scope", "$uibModal", "$stateParams", "ManageGroupsService",
    function ($scope, $uibModal, $stateParams, ManageGroupsService) {


    }
]);